import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  saveLoadingById: false,
  technicalKnowledgeAcquiredsLength: 0,
  technicalKnowledgeAcquireds: [],
  technicalKnowledgeAcquired: {},
  technicalKnowledgeAcquiredError: "",
  formError: "",
};

export default function TechnicalKnowledgeAcquiredReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED:
      return { ...state, loading: action.payload };
    case actions.LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED:
      return { ...state, saveLoading: action.payload };
    case actions.SAVE_LOADING_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID:
      return { ...state, saveLoadingById: action.payload };
    case actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED:
      return {
        ...state,
        technicalKnowledgeAcquireds: action.payload.technicalKnowledgeAcquireds,
        technicalKnowledgeAcquiredsLength: action.payload.technicalKnowledgeAcquiredsLength,
      };
    case actions.GET_TECNICAL_KNOWLEDGE_ACQUIRED_BY_ID:
      return {
        ...state,
        technicalKnowledgeAcquired: action.payload,
      };
    case actions.FORM_FAIL_TECNICAL_KNOWLEDGE_ACQUIRED:
      return { ...state, formError: action.payload };
    case actions.TECNICAL_KNOWLEDGE_ACQUIRED_FAIL:
      return { ...state, technicalKnowledgeAcquiredError: action.payload };
    default:
      return state;
  }
}
